module.exports = __webpack_public_path__ + "assets/icons/ic_work_24px.svg";